import React from "react";
import logo from "../../assets/images/user-icon.svg";

const userLogo = props => (
  <img className={props.className} src={logo} alt="user" />
);

export default userLogo;
